import React from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import utils from '../../../../../components/Organisms/Form/utils'

import { ExternalLink } from 'src/components/Core/Styles/Link'
import Font from 'src/components/Core/Typography/Font/Font'
import { RequiredMark } from 'src/components/Atoms/Label/Label.styles'

export const dataProtectionLink = <ExternalLink href='https://www.sucdenfinancial.com/en/op/data-protection-and-privacy-policy' />

const SucdenAndHolderAgreementAndDocumentsText = (
  <Font key='sucdenAndHolderAgreementAndDocumentsText' ellipsis={false}>
    <Trans i18nKey={'onboarding.forms.IndividualAccount.DeclarationsForm.visualOnly.sucdenAndHolderAgreementAndDocumentsText'} />
  </Font>
)

const MarketingCommunications = (
  <Font key='marketingCommunications' ellipsis={false}>
    <Trans i18nKey={'onboarding.forms.IndividualAccount.DeclarationsForm.visualOnly.marketingCommunications'} components={{requiredMark: <RequiredMark />}}/>
  </Font>
)

const Marketing = (
  <Font key='marketing' ellipsis={false} tag='h4'>
    {t('onboarding.forms.IndividualAccount.DeclarationsForm.visualOnly.marketing')}
  </Font>
)

const config = utils.injectTranslation({
  id: 'DeclarationsForm',
  path: 'onboarding.forms.IndividualAccount.DeclarationsForm.inputs',
  keysToRemove: ['visual', 'documentID'],
  content: [
    {
      componentType: 'grid',
      props: {
        marginBottom: '12px'
      },
      content: [
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'certifyAccountHolder',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
            //@ts-ignore 
            label: <Trans i18nKey={'onboarding.forms.IndividualAccount.DeclarationsForm.inputs.certifyAuthorisedSign.label'} />,
            // required: true
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'allStatmentsMadeCorrect',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
            // required: true
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'takeSucdenAdvise',
            labelProps: {
              labelHeight: 'auto',
              labelDisplay: 'inline-block',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
            //@ts-ignore 
            label: <Trans i18nKey={'onboarding.forms.IndividualAccount.DeclarationsForm.inputs.takeSucdenAdvise.label'} />,
            // required: true
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'dataProtectionPolicyConfirmation',
            labelProps: {
              labelHeight: 'auto',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {dataProtectionLink},
            // required: true
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'acknowledgeInformationOnForm',
            labelProps: {
              labelHeight: 'auto',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            //@ts-ignore 
            label: <Trans i18nKey={'onboarding.forms.IndividualAccount.DeclarationsForm.inputs.informationAcknowledgement.label'} />,
            // required: true
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'fundsRiskConfirmation',
            labelProps: {
              labelHeight: 'auto',
              labelDisplay: 'inline-block',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
            // required: true
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'agreeToBoundForProvisions',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
            // required: true
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        marginBottom: '32px'
      },
      content: [
        {
          componentType: '',
          visualComponent: SucdenAndHolderAgreementAndDocumentsText
        }
      ]
    },
    {
      componentType: 'grid',
      props: {
        marginBottom: '16px'
      },
      content: [
        {
          componentType: '',
          visualComponent: Marketing
        }
      ]
    },
    {
      componentType: 'grid',
      props: {
        marginBottom: '8px'
      },
      content: [
        {
          componentType: '',
          visualComponent: MarketingCommunications
        }
      ]
    },
    {
      componentType: 'grid',
      props: {
        marginBottom: '8px'
      },
      content: [
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'optForInfoByMail',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            }
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'optForInfoByEMail',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'optForInfoByPhone',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'notOptForInformation',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
      ]
    },
  ],
})

export default config
